import { render, staticRenderFns } from "./TractTickets.vue?vue&type=template&id=704598c6&"
import script from "./TractTickets.vue?vue&type=script&lang=js&"
export * from "./TractTickets.vue?vue&type=script&lang=js&"
import style0 from "./TractTickets.vue?vue&type=style&index=0&id=704598c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports